<template>
	<div>
		板块：
		<div v-bind:key="plate.index" v-for="plate in plates">
			<b-badge class="m-1 float-left">{{plate[1]}}</b-badge>
		</div>
	</div>
	
</template>

<script>
	import {
		request_zzquant
	} from "network/request.js"

	export default {
		props: {
			symbol_code: String
		},
		computed: {

		},
		components: {

		},
		watch: {
			symbol_code: 'refresh'
		},
		data() {
			return {
				plates:[]
			}
		},
		mounted() {
			this.refresh();
		},
		methods: {
			refresh() {
				request_zzquant({
					'url': 'open/stock/' + this.symbol_code+'/info/12'
				}).then(res=>{
					// console.log(res);
					this.plates  = res['data']['data']['ListJX'];
				})
			}

		}
	}
</script>

<style>
</style>
